const isAllChecked = (action: any): boolean => {
  return Object.values(action).every(notificationType => {
    return Object.values(notificationType).every(item => item === true)
  })
}

const notifications = (state: any = {}, action: any) => {
  switch (action.type) {
    case 'RECEIVE_NOTIFICATIONS':
      return {
        ...state,
        model: action.notifications,
        dirtyModel: action.notifications,
        checkAll: isAllChecked(action.notifications),
      };
    case 'UPDATE_NOTIFICATIONS':
      return { ...state, model: state.model, dirtyModel: { ...action.newModel }, checkAll: isAllChecked(action.newModel) };
    case 'RESET_NOTIFICATIONS':
      return { ...state, dirtyModel: state.model }
    case 'CHECK_ALL':
      return { ...state, dirtyModel: action.newModel, checkAll: !state.checkAll }
    case 'SAVE':
      return { ...state, model: state.dirtyModel}
    default:
      return state;
  };
}

export default notifications;
